import React from 'react';
import { ChartBar, ChartLine } from '@phosphor-icons/react';
import { cn } from '../../lib/utils';

export const TIME_SERIES_TYPES = [
  { value: 'column', label: 'Columns', icon: ChartBar },
  { value: 'line', label: 'Line', icon: ChartLine },
];

/** Compact Line / Columns control for revenue & AOV trend charts. */
export function TimeSeriesTypeToggle({ value = 'column', onChange, className }) {
  return (
    <div
      role="group"
      aria-label="Chart type"
      className={cn(
        'inline-flex items-center rounded-full border border-slate-200 bg-white p-0.5 shadow-sm',
        className
      )}
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
    >
      {TIME_SERIES_TYPES.map((option) => {
        const Icon = option.icon;
        const active = value === option.value;
        return (
          <button
            key={option.value}
            type="button"
            aria-pressed={active}
            onClick={() => onChange?.(option.value)}
            className={cn(
              'inline-flex h-7 items-center gap-1 rounded-full px-2.5 text-[11px] font-semibold transition',
              active
                ? 'bg-[var(--brand-primary,#1A428A)] text-white shadow-sm'
                : 'text-slate-500 hover:bg-slate-50 hover:text-slate-700'
            )}
          >
            <Icon size={13} weight={active ? 'bold' : 'regular'} aria-hidden="true" />
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
